import { IntroIFrame, IntroWrapper } from './__intro-elements';
import { HelpModeReminder, StartTour, TutorialsReminder } from './_intro-app';
import { IntroKeys } from './intro-keys';

const Highlights = () => (
  <IntroWrapper>
    <p>
      <b>Highlights</b> page: <b>Tag the highlights</b> in your source files.
    </p>
  </IntroWrapper>
);

const HighlightsIntro = () => (
  <IntroWrapper size="medium">
    <p>
      Pulse is designed to help users <b>edit very quickly</b>. The most time consuming part of editing uncut source
      footage is finding the highlights.
    </p>
    <p>
      The <b>Highlights</b> page provides an interface for users to <b>tag highlights quickly</b>.
    </p>
    <IntroIFrame src="https://www.youtube.com/embed/zIsXryrl_q0" />
  </IntroWrapper>
);

const HighlightsFile = () => (
  <IntroWrapper>
    <p>Select a source file.</p>
  </IntroWrapper>
);

const SrSeek = () => (
  <IntroWrapper>
    <p>Quickly seek for the best moments..</p>
  </IntroWrapper>
);

const AddTag = () => (
  <IntroWrapper>
    <p>When you find a highlight, tag it.</p>
  </IntroWrapper>
);

const SrGrid = () => (
  <IntroWrapper>
    <p>
      Your highlight is added here. <b>Move on quickly to find the next highlight</b> (we are trying to be quick!), you
      can refine them on the storyboard later.
    </p>
  </IntroWrapper>
);

const AddTag2 = () => (
  <IntroWrapper>
    <p>Tag multiple highlights from each file.</p>
  </IntroWrapper>
);

const Stats = () => (
  <IntroWrapper>
    <p>These stats estimate how many highlights you should add to populate your storyboard.</p>
  </IntroWrapper>
);

const NavSb = () => (
  <IntroWrapper>
    <p>
      When you have finished tagging highlights, navigate to the <b>Storyboard</b> page.
    </p>
  </IntroWrapper>
);

export const STEPS_SR = [
  { element: `[data-intro="${IntroKeys.navSr}"]`, intro: <Highlights /> },
  { element: `[data-intro="${IntroKeys.navHelpMode}"]`, intro: <HelpModeReminder /> },
  { element: `[data-intro="${IntroKeys.navStartTour}"]`, intro: <StartTour /> },
  { element: `[data-intro="${IntroKeys.navTutorials}"]`, intro: <TutorialsReminder /> },
  { intro: <HighlightsIntro /> },
  { element: `[data-intro="${IntroKeys.srFile}"]`, intro: <HighlightsFile /> },
  { element: `[data-intro="${IntroKeys.srSeek}"]`, intro: <SrSeek /> },
  { element: `[data-intro="${IntroKeys.srAddClip}"]`, intro: <AddTag /> },
  { element: `[data-intro="${IntroKeys.srGrid}"]`, intro: <SrGrid /> },
  { element: `[data-intro="${IntroKeys.srAddClip}"]`, intro: <AddTag2 /> },
  { element: `[data-intro="${IntroKeys.srStats}"]`, intro: <Stats /> },
  { element: `[data-intro="${IntroKeys.navSb}"]`, intro: <NavSb /> },
];
